import styled from 'styled-components/macro';

import HeadingBase from '@components/common/core/DataDisplay/Heading';

export const Title = styled(HeadingBase)``;

export const Wrapper = styled.div`
  margin-bottom: 24px;
`;
